import { render, staticRenderFns } from "./ProductBottomLinksNew.vue?vue&type=template&id=6ab3b9f0"
import script from "./ProductBottomLinksNew.vue?vue&type=script&lang=js"
export * from "./ProductBottomLinksNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports